import { FragmentType, graphql, useFragment } from '@/generated/gql'
import { CardContent, Stack, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

const canteenMenuItemSourcingVendorDataFragment = graphql(`
  fragment CanteenMenuItemSourcing_VendorDataFragment on Vendor {
    id
    sourcing
    companyName
    translations {
      key
      value
      language
    }
  }
`)

type Props = {
  vendorData: FragmentType<typeof canteenMenuItemSourcingVendorDataFragment>
}

const MenuItemSourcing: React.FC<Props> = ({ vendorData: vendorDataProp }) => {
  const { sourcing, companyName } = useFragment(
    canteenMenuItemSourcingVendorDataFragment,
    vendorDataProp,
  )
  const { t } = useTranslation()
  return (
    <CardContent>
      <Stack spacing={3} direction="column">
        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle3">
            {sourcing ? 'Sourcing' : 'There is no sourcing information yet'}
          </Typography>
          {sourcing ? (
            <Typography color="text.secondary" variant="body2">
              ({t('cc:allInformationProvidedBy')} {companyName})
            </Typography>
          ) : null}
        </Stack>
        {sourcing ? <Typography variant="subtitle3">{t('cc:ingredientSources')}</Typography> : null}
        <Typography variant="body1" color="text.secondary">
          {sourcing || `We are waiting for information to be supplied by ${companyName}`}
        </Typography>
      </Stack>
    </CardContent>
  )
}

export default MenuItemSourcing
